import React, { Fragment, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { sendAnalytics } from '../../../utils/analyticsUtils';
import BZPopover from 'web-common/bizzabo-components/components/BZPopover';
import LoginPopover from './LoginPopover';
import { OverlayTrigger, Tooltip, Row} from 'react-bootstrap';
import SessRegPopover from './SessRegPopover';
import { rgbToAlfa } from '../../../selectors/UtilSelectors';
import { getScreenWidth } from '../../Utils';
import { getSessionRegButtonStatus, isSaveASeatVisible } from '../../../selectors/AgendaSelectors';
import { S_WIDTH, loginClickOrigin } from '../../../constants/Enums';
import TicketsRegistrationPopoverContainer from './TicketsRegistrationPopoverContainer';
import AgendaShareButton from './AgendaShareButton';
import AddToCalendarButton from './AddToCalButton';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    interestSubCategory,
    saveASeatSubCategory
} from '../../../constants/SnowplowConst';


export const REGISTERED = 'REGISTERED';
export const NOT_REGISTERED = 'NOT_REGISTERED';
export const DISABLED = 'DISABLED';
export const NONE = 'NONE';
const shouldNotifySP = true;

const SessionActions = ({
    me,
    eventUrls,
    session = {},
    toggleMarker,
    showEmailLogin,
    sessionViewType,
    buttonsDirectionHorizontal,
    toggleSessionRegistrationStatusPerSession,
    openCloseTicketSelectionPopUp,
    sessionView,
    color,
    ticketsSelectionData: {
        tickets,
        selectedTicketsIds
    },
    websiteType,
    event,
    setSessionFullRegistration,
    index,
    shouldStickAgendaSearch,
    showAddToCal,
    siteConf,
    setLoginV2OffsetTop,
}) => {
    const {
        isInFavourite,
        addToCalMarker,
        id: sessionId,
        isRegistered,
        disableType,
        ticketsRegisteredSessionIds
    } = session || {};
    const isAuthorized = me && me.id;
    const isTicketSelectedOrDefault = !!selectedTicketsIds.length || tickets != null && tickets.length===1;
    const { sessRegStatus, shouldRenderSessRegButton} = getSessionRegButtonStatus(session, isAuthorized, tickets, selectedTicketsIds);
    const saveASeatVisible = isSaveASeatVisible(shouldRenderSessRegButton, sessionView, isAuthorized, isTicketSelectedOrDefault);
    const featureAgendaShare = FeatureToggleUtils.isFeatureEnabled('agendaShare');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(false);
    }, [sessRegStatus]);

    const sessionActionsContainerCls = classname('session-actions-container color-1-border', {
        'single-button': !saveASeatVisible,
        'vertical': saveASeatVisible
    });
    const sessionStarButtonCls = classname('custom-color session-action-container', {
        selected: isInFavourite,
        'display-inline-block': buttonsDirectionHorizontal,
        'display-block': !buttonsDirectionHorizontal
    });
    const sessionStarCls = classname('custom-color color-1 starIcon', {
        'icon-lead_on': isInFavourite,
        'icon-lead_off': !isInFavourite,
        'two-action-grid': shouldRenderSessRegButton && !sessionView
    });
    const sessRegCls = classname('custom-color', {
        'icon-Chair_OFF color-1': sessRegStatus && sessRegStatus === NOT_REGISTERED,
        'icon-Chair_ON color-1': sessRegStatus && sessRegStatus === REGISTERED,
        'icon-Chair_Overlap agenda-light-gray': sessRegStatus && sessRegStatus === DISABLED
    });
    const separatorCls = classname('session-actions-separator', {
        'display-inline-block horizontal': buttonsDirectionHorizontal,
        'display-block vertical': !buttonsDirectionHorizontal
    }, ' custom-color color-1-border');

    const myInterestsRef = useRef();
    const saveASeatRef = useRef();

    const sessionStarClickHandler = (withTriggerToSP = false) => {
        if (withTriggerToSP) {
            const subCategory = isInFavourite ? interestSubCategory.markAsNotInterests : interestSubCategory.markAsInterests;
            sendCustomClick(buttonTypes.markInterest, subCategory, myInterestsRef);
        }
        if (isAuthorized) {
            toggleMarker(addToCalMarker);
        }

        const eventName = isInFavourite ? 'removeSessionFromFavourites' : 'addSessionToFavourites';
        sendAnalytics(eventName, {
            sessionId,
        });
    };

    const addSessionOnSaveSeatClick = (sessionId, ticketId) => {
        if (!isInFavourite) sessionStarClickHandler();

        sendAnalytics('saveSeat', {
            sessionId,
        });
    };

    const closePopOver = () => document.body.click();

    const saveASeatClass = classname('session-button', {checked: sessRegStatus && sessRegStatus === REGISTERED});
    const saveASeatText = sessRegStatus === NOT_REGISTERED || sessRegStatus === DISABLED ? 'Save seat' : 'Seat saved!';

    const backgroundColor = color && rgbToAlfa(color, 0.15);
    const saveASeatInitialAnalyticHandler = () => {
        const notRegistered = sessRegStatus && sessRegStatus === NOT_REGISTERED && 'notRegistered';
        const register = sessRegStatus && sessRegStatus === REGISTERED && 'register';
        const disabled = sessRegStatus && sessRegStatus === DISABLED && 'disabled';
        const sessionRegisterStatus = notRegistered || register || disabled;
        const subCategory = saveASeatSubCategory[sessionRegisterStatus] || '';
        sendCustomClick(buttonTypes.saveSeat, subCategory, saveASeatRef);
    };

    const myInterestInner = () =>
        sessionView
            ? <div
                className={classname('session-button', {checked: isInFavourite})}
                style={isInFavourite? { backgroundColor: `var(--page-main-color-opacity-10, ${backgroundColor})` } : {}}
                ref={myInterestsRef}
                onClick={() => sessionStarClickHandler(shouldNotifySP)}>
                <i className={sessionStarCls} />
                <span className={classname({ 'color-1': isInFavourite })}>
                    Interested
                </span>
            </div>
            : <span
                ref={myInterestsRef}
                className={sessionStarButtonCls}
                onClick={() => sessionStarClickHandler(shouldNotifySP)}>
                <i className={sessionStarCls} />
            </span>;

    const saveASeatInner = () => {
        if (!sessionView) {
            return isLoading
                ? <></>
                : <span
                    className={sessionStarButtonCls}
                    ref={saveASeatRef}
                    onClick={saveASeatInitialAnalyticHandler}>
                    <i className={sessRegCls} />
                </span>;
        }

        if (isAuthorized && isTicketSelectedOrDefault) {
            return <div
                onClick={saveASeatInitialAnalyticHandler}
                ref={saveASeatRef}
                style={sessRegStatus && sessRegStatus === REGISTERED ? { backgroundColor: `var(--page-main-color-opacity-10, ${backgroundColor})` } : {}}
                className={saveASeatClass}>
                <i className={sessRegCls} />
                <span className={classname({ 'color-1': sessRegStatus && sessRegStatus === REGISTERED })}>
                    { saveASeatText }
                </span>
            </div>;
        }

        return <div />;
    };

    const getOverlay = (overlayText, component) =>
        <OverlayTrigger
            delayShow={1000}
            delayHide={100}
            trigger={getScreenWidth() > S_WIDTH ? ['hover', 'focus'] : []}
            placement="bottom"
            overlay={<Tooltip id='table-tooltip'>{overlayText}</Tooltip>}>
            {component}
        </OverlayTrigger>;

    const saveASeatTooltipText = () => sessRegStatus && sessRegStatus === REGISTERED ? 'Give up your seat' : 'Save a seat';

    const getRegisterBtnMessage = (disableType) => {
        let msg = '';

        switch (disableType) {
        case 'maxLimitReached':
            msg = 'You’ve reached the limit of sessions to register for.';
            break;
        case 'registrationFull':
            msg = 'This session has reached its capacity limit.';
            break;
        case 'overlapping':
            msg = 'This session overlaps with a session you are already registered for.';
            break;
        default:
            msg = 'Save a seat';
            break;
        }

        return msg;
    };

    const scrollAndShowPopup = () => {
        openCloseTicketSelectionPopUp();

        if (websiteType != null && websiteType === 'bizzabo' || websiteType === 'whitelabel') {
            $('html, body').animate({
                scrollTop: 0
            }, 'fast');
        }
    };

    const saveASeatCallback = (ticketId) =>
        () => {
            const isRegistered = ticketsRegisteredSessionIds[ticketId] && ticketsRegisteredSessionIds[ticketId].includes(sessionId);
            const toRegister = !isRegistered;
            toRegister && addSessionOnSaveSeatClick(sessionId, ticketId);

            toggleSessionRegistrationStatusPerSession(sessionId, toRegister, ticketId).catch(console.error);
        };

    const getSaveASeatPopover = (popoverPosition) => {
        // Not authorized => show login popup
        if (!isAuthorized) return <BZPopover
            placement={sessionView ? 'bottom' : 'right'}
            cls="need-login-popover"
            button={getOverlay(saveASeatTooltipText(), saveASeatInner())}
            popover={
                <LoginPopover
                    onLoginClick={showEmailLogin}
                    eventUrls={eventUrls}
                    setLoginV2OffsetTop={setLoginV2OffsetTop}
                    isWidget={siteConf?.isWidget}
                />
            }
        />;

        // No ticket selection => show ticket selection popup
        if (!isTicketSelectedOrDefault) return <div onClick={scrollAndShowPopup}>
            <OverlayTrigger
                delayShow={1000}
                delayHide={100}
                trigger={getScreenWidth() > S_WIDTH ? ['hover', 'focus'] : []}
                placement="bottom"
                overlay={<Tooltip id='table-tooltip'>{getRegisterBtnMessage(null)}</Tooltip>}>
                {saveASeatInner()}
            </OverlayTrigger>
        </div>;

        const singleTicket = selectedTicketsIds.length<=1;
        // Can't save a seat (e.g. Capacity limit) => Show dedicated popup
        if (singleTicket && disableType) {
            return <OverlayTrigger
                delayShow={1000}
                delayHide={100}
                trigger={getScreenWidth() > S_WIDTH ? ['hover', 'focus'] : []}
                placement="bottom"
                overlay={<Tooltip id='table-tooltip'>{getRegisterBtnMessage(disableType)}</Tooltip>}>
                {saveASeatInner()}
            </OverlayTrigger>;
        }

        const popup = singleTicket
            // show save/remove seat popup
            ? <SessRegPopover
                initialState={isRegistered ? REGISTERED : NOT_REGISTERED}
                action={ toggleSessionRegistrationStatusPerSession }
                onDone={ closePopOver }
                isAuthorized={ isAuthorized }
                addSessionOnSaveSeatClick={addSessionOnSaveSeatClick}
                sessionId={sessionId}
                ticketId={selectedTicketsIds[0]}
                setSessionFullRegistration={setSessionFullRegistration}/>
            // show tickets popup to save a seat
            : <TicketsRegistrationPopoverContainer
                closePopOver={closePopOver}
                saveASeatCallback={saveASeatCallback}
                getRegisterBtnMessage={getRegisterBtnMessage}
                saveASeatTooltipText={saveASeatTooltipText}
                session={session}
                isAuthorized={ isAuthorized }
                sessionView={sessionView}
                isTicketSelectedOrDefault={isTicketSelectedOrDefault} />;

        const singleTicketsCls = classname('session-actions-popover',
            {'preview-window': sessionViewType === 'sessionPreviewWindow'});

        const multiTicketsCls = classname('tickets-registration-overlay',
            {[`sticky-first-session-${index}`]: shouldStickAgendaSearch},
            {'preview-window': sessionViewType === 'sessionPreviewWindow'});

        return <BZPopover
            placement={popoverPosition}
            cls={classname(
                {[singleTicketsCls]: singleTicket},
                {[multiTicketsCls]: !singleTicket},
                { 'registered': isRegistered })}
            button={ getOverlay(saveASeatTooltipText(), saveASeatInner())}
            popover={popup}
        />;

    };

    const classForActionButtonWrapper = (current) => (`session-action-wrapper ${current}`);

    const starredTooltipText = () => isInFavourite ? 'Remove from My interests' : 'Add to My Interests';

    const sessionActions = () =>
        <div className={sessionActionsContainerCls}>
            { isAuthorized ?
                getOverlay(starredTooltipText(), myInterestInner()) :
                <BZPopover
                    placement={sessionView ? 'bottom' : 'right'}
                    cls="need-login-popover"
                    button={getOverlay(starredTooltipText(), myInterestInner())}
                    popover={
                        <LoginPopover
                            onLoginClick={showEmailLogin}
                            eventUrls={eventUrls}
                            setLoginV2OffsetTop={setLoginV2OffsetTop}
                            isWidget={siteConf?.isWidget}
                            analyticData={{
                                clickOrigin: loginClickOrigin.agenda.interestStar,
                                sessionId: session?.id,
                            }}
                        />
                    }
                />
            }
            { saveASeatVisible
                && <Fragment>
                    <span className={separatorCls} />
                    { getSaveASeatPopover('right') }
                </Fragment> }
        </div>;

    const scheduled = session && session.startDate && session.startMinute >= 0 && session.endDate && session.endMinute >= 0;
    const sessionViewActions = () =>
        <Row className='session-view-action'>
            <div className={ classForActionButtonWrapper('starred') }>
                { isAuthorized ? getOverlay(starredTooltipText(), myInterestInner()) :
                    <BZPopover
                        placement={sessionView ? 'bottom' : 'right'}
                        cls="need-login-popover"
                        button={getOverlay(starredTooltipText(), myInterestInner())}
                        popover={
                            <LoginPopover
                                onLoginClick={showEmailLogin}
                                eventUrls={eventUrls}
                                setLoginV2OffsetTop={setLoginV2OffsetTop}
                                isWidget={siteConf?.isWidget}
                                analyticData={{
                                    clickOrigin: sessionViewType === 'sessionPreviewWindow'
                                        ? loginClickOrigin.sessionPreview.interestStar
                                        : loginClickOrigin.session.interestStar,
                                    sessionId: session?.id
                                }}
                            />
                        }
                    />
                }
            </div>
            {saveASeatVisible &&
                <>
                    <span className='separator'/>
                    <div className={ classForActionButtonWrapper('seat') }>
                        { getSaveASeatPopover('bottom') }
                    </div>
                </>
            }
            {scheduled && showAddToCal &&
                <>
                    <span className='separator'/>
                    <div className={classForActionButtonWrapper('calendar')}>
                        <AddToCalendarButton
                            event={event}
                            color={color}
                            session={session}
                            sessionViewType={sessionViewType}
                            me={me}
                            eventUrls={eventUrls} />
                    </div>
                </>
            }
            {featureAgendaShare &&
                <>
                    <span className='separator'/>
                    <div className={classForActionButtonWrapper('share')}>
                        <AgendaShareButton entityToShare='Session' color={color} event={event} eventUrls={eventUrls} entityId={session?.id}/>
                    </div>
                </>
            }
        </Row>;

    const actionButtons = sessionView ? sessionViewActions() : sessionActions();

    return actionButtons;
};

SessionActions.propTypes = {
    me: PropTypes.object.isRequired,
    eventUrls: PropTypes.object.isRequired,
    session: PropTypes.object.isRequired,
    toggleMarker: PropTypes.func.isRequired,
    showEmailLogin: PropTypes.func.isRequired,
    sessionViewType: PropTypes.string,
    toggleSessionRegistrationStatusPerSession: PropTypes.func,
    openCloseTicketSelectionPopUp: PropTypes.func,
    event: PropTypes.object.isRequired,
    color: PropTypes.string,
    setSessionFullRegistration: PropTypes.func,
    index: PropTypes.number,
    showAddToCal: PropTypes.bool,
};


export default SessionActions;
